export default "__VITE_ASSET__311c6527__"